module.exports = __webpack_public_path__ + "static/media/drew_boards.f766f052.jpg";